import Layout from '../components/layout/Layout';

export default () => (
  <Layout>
    <main class="mt-10 mb-10 md:mb-32 mx-auto max-w-screen-xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 xl:mt-28">
      <div class="text-center">
        <h2 class="text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-6xl">
          Green-e Certificates & Projects
        </h2>
        <p class="mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-xl ">
          These carbon offset content labels explain information about the greenhouse gas emissions
          reductions you are purchasing through Carbon Offset Green Gas. It is a simple, transparent
          way for you to be certain your purchase is resulting in real environmental benefits.
        </p>

        <div class="mt-12 max-w-md mx-auto sm:flex sm:justify-center md:mt-8">
          <div class="rounded-md">
            <a
              href="https://imgix.cosmicjs.com/d4c06810-f609-11eb-9c1d-cfc0f227e9c6-CO2-2021-Kratos-Product-Content-Label.pdf"
              target="blank"
              class="mt-3 rounded-lg text-white sm:mt-0 sm:ml-3 sm:flex-shrink-0 bg-green-500 px-14 py-3 hover:bg-green-600 transition ease-in duration-200"
            >
              2021 CARBON OFFSET CONTENT LABEL
            </a>
          </div>
        </div>
      </div>
    </main>
  </Layout>
);
